// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2879":"bc683a8b","4387":"bc683a8b","5151":"bc683a8b","7748":"bc683a8b","8034":"bc683a8b","8956":"bc683a8b"}[chunkId] + ".chunk.css";
};